import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectLoginToken } from '@/features/login/loginSlice';

export const useAuth = () => {
  const token = useSelector(selectLoginToken);

  return useMemo(() => ({ token }), [token]);
};
